// NGC Flow slot default values
// These values are used when the Monarch slot doesn't provide data
// Note: useMonarchSlot extracts the component's `data` property,
// so we receive the config values directly (flat structure)

type SimplifiedRecommendedPlansCta = {
  enabled: boolean;
  version: string;
  collapsed: {
    collapsible: boolean;
    startCollapsed: boolean;
  };
};

export type NgcFlowSlotData = {
  ngcFlow: "v1" | "v2" | "v3" | "v4";
  model: "ml" | "revenue_ml";
  showFaq: boolean;
  showMoreDetailsByop: boolean;
  altProductExplainerVersion: "v2" | "v3";
  v2AddOnCheckbox: boolean;
  claimRewardsLocation: "default" | "header";
  enableStickyCtaOnQuiz: boolean;
  showTraditionalCTA: boolean;
  simplifiedRecommendedPlansCta?: SimplifiedRecommendedPlansCta;
  defaultExpandedPlanCards: "recommendedOnly" | "all" | "none";
  enableAbove3RecLtoBanner: boolean;
  broadbandBelowCards: boolean;
};

export const ngcFlowDefaultValue: NgcFlowSlotData = {
  ngcFlow: "v2",
  model: "ml",
  showFaq: false,
  showMoreDetailsByop: true,
  altProductExplainerVersion: "v2",
  v2AddOnCheckbox: false,
  claimRewardsLocation: "default",
  enableStickyCtaOnQuiz: false,
  showTraditionalCTA: false,
  simplifiedRecommendedPlansCta: undefined,
  defaultExpandedPlanCards: "recommendedOnly",
  enableAbove3RecLtoBanner: false,
  broadbandBelowCards: false,
};
